import FooterMenu from "./FooterMenu";

// Export without redux connection
export default FooterMenu;
